import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Functions } from "../../../helpers/Functions.jsx";

const UnidadFamiliarModal = ({ show, onClose, onSave, showCreate, title, categoriasEvaluacion, initDataUnidadFamiliar }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, reset: resetModal, getValues: getValuesModal, setValue: setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [detalles, setDetalles] = useState(CONFIGURACIONES.INIT.ARRAY);

    const selectCategorias = useMemo(() => {
        return categoriasEvaluacion.filter(categoria => categoria.aplicado_a == CONFIGURACIONES.INIT.LIST_CATEGORIAS.UNIDAD_FAMILIAR);
    }, [categoriasEvaluacion]);

    useEffect(() => {
        resetModal();
        if (initDataUnidadFamiliar !== CONFIGURACIONES.INIT.NULL) {
            setValueModal('totalUnidadFamiliar', initDataUnidadFamiliar.total);
            setDetalles(initDataUnidadFamiliar.detalles);
        }
    }, [initDataUnidadFamiliar]);

    
    useMemo(() => {
        let total = 0;
        detalles.forEach((item) => {
            total += parseFloat(item.importe);
        });
        setValueModal('totalUnidadFamiliar', isNaN(total) ? '' : total.toFixed(2));
        return isNaN(total) ? '' : total.toFixed(2); 
    }, [detalles]);

    const onAgregarItem = (form) => {
        const {totalUnidadFamiliar, ...form2} = form;
        form2['id'] = Functions().generarNumeroUnico(detalles);
        setDetalles([...detalles, form2]);
        resetModal();
    };

    const saveData = () => {
        let data = {
            'total': getValuesModal('totalUnidadFamiliar'),
            'detalles': detalles
        }

        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onAgregarItem)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-5">
                                <div className="form-group">
                                    <label htmlFor="tipoGasto" className="control-label col-form-label">Tipo de Gasto <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("tipoGasto", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                        })} className="form-control" id="tipoGasto"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            selectCategorias.map((el, index) => (
                                                <option key={index} value={el.nombre}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.tipoGasto && errorsModal.tipoGasto.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="importe" className="control-label col-form-label">Importe <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="importe"
                                        id="importe"
                                        {...registerModal("importe", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.importe && errorsModal.importe.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row my-1">
                            <div className="col-sm-12 col-md-3">
                                <WaveButton className="btn btn-sm btn-outline-info wave-effect" type="submit">
                                    <i className="mdi mdi-plus"></i> Agregar
                                </WaveButton>
                            </div>
                        </div>

                        {/* 📊 Tabla */}
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                            <table className="table table-sm table-hover compact-table align-middle text-wrap">
                                <thead className="bg-success text-white">
                                <tr>
                                    <th>Tipo de Gasto</th>
                                    <th style={{width: '100px'}}>Importe</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {detalles.length > 0 ? (
                                    detalles.map((item) => (
                                        <tr key={item.id}>
                                            <td className="text-wrap">{item.tipoGasto}</td>
                                            <td className="text-wrap">{item.importe}</td>
                                            <td>
                                                <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                                                    setDetalles(detalles.filter((detalle) => detalle.id !== item.id));
                                                }}>
                                                    <i className="mdi mdi-delete"></i>
                                                </WaveButton>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center text-muted">
                                            <span className="text-danger">No se encontraron resultados</span>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="totalUnidadFamiliar" className="control-label col-form-label">Total <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="totalUnidadFamiliar"
                                        id="totalUnidadFamiliar"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        {...registerModal("totalUnidadFamiliar", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.totalUnidadFamiliar && errorsModal.totalUnidadFamiliar.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="button" className="btn btn-sm btn-success waves-effect" onClick={saveData}>
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default UnidadFamiliarModal;
